import { render, staticRenderFns } from "./DialogConsistency.vue?vue&type=template&id=12bf1ef8&"
import script from "./DialogConsistency.vue?vue&type=script&lang=js&"
export * from "./DialogConsistency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports